export interface IConfig {
    menus?: string[];
    excludeMenus?: string[];
    placeholder?: string;
    teacherId?: string;
    menuBarFixTop?: number;
}

export enum E_PLATFORM {
    PC = 'pc',
    mobile = 'mobile',
}
